<template>
    <div id="siteHeader" :class=" (mobileMenuOpen ? 'open' : '') + ' ' + headerSize + ' ' + route">

        <div class="brand">
            <router-link :to="{name: 'homepage'}"><LogoVivamod /></router-link>
        </div>
            
        <div class="menu">

            <div class="menu--content">
            
                <div class="menu--navigation">
                    <Navigation />
                </div>

                <!-- ambalagi pubblico gira come "integrato" con anagrafica specifica
                        il mixin
                        blic verifica se si è in modalità "sito pubblico"
                <div class="menu--user">
                    <User />
                </div> -->

            </div>

        </div>

        <div v-if="false" class="toggle" @click="toggleMenu">
            <SvgHamburger />
        </div>

    </div>
</template>

<script>
    import Navigation from '@/components/blocks/header/navigation'
    //import User from '@/components/blocks/header/user'
    import SvgHamburger from '@/components/svg/chevron-down-toggler'
    import LogoVivamod from '@/components/svg/logo-vivamod'

    export default {
        name: 'siteHeader',
        components: {
            Navigation,
            //User,
            SvgHamburger,
            LogoVivamod,
        },
        computed:
        {


        },
        watch: {
            '$route.name': function()
            {
                this.setupHeaderGui()
            }
        },
        data() {
            return {
                headerSize: '',
                mobileMenuOpen: false,
                route: '',
            }
        },
        methods:
        {
            setupHeaderGui()
            {
                this.mobileMenuOpen = false
                this.headerSize = 'large'
                this.route = this.$router.currentRoute.name
                //if(this.$router.currentRoute.name == 'homepage') this.headerSize = 'large'
                //if(this.$router.currentRoute.name == 'in-vadobay') this.headerSize = 'large'
            },
            toggleMenu()
            {
                this.mobileMenuOpen = !this.mobileMenuOpen
                if(this.mobileMenuOpen)
                {
                    document.body.classList.add('menuOpen')
                }
                else
                {
                    document.body.classList.remove('menuOpen')
                }
            },
        },
        mounted()
        {
            this.setupHeaderGui()
        }
    }
</script>

<style lang="scss">
    @import "~bootstrap/scss/functions";
    @import "~bootstrap/scss/mixins";
    @import './../../../scss/_custom.scss';

    #siteHeader
    {
        $header-position: absolute; //fixed

        width:100%;
        //height:$page-header-mobile-height;
        position:$header-position;
        top:0;//$grid-gutter-width/4;
        z-index: 999;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding:$grid-gutter-width/3;
        //padding:0 $grid-gutter-width/4;

        &.concorsi
        {
            .brand
            {
                path
                {
                    fill:$white;
                }
            }
        }

        .brand
        {
            width:200px;
            max-width: 40vw;
            position:relative;
            z-index:1;
            img,svg
            {
                max-width: 100%;
                height: auto;
            }
            @include media-breakpoint-up(sm)
            {
                max-width: none;
            }

            @include media-breakpoint-up(xl)
            {
                width:300px;
                margin-top:$grid-gutter-width;
                margin-left:$grid-gutter-width/2;
            }
        }
        .menu
        {
            display:none;
            opacity:0;
            transition:all 1s ease-in-out;
            background:#fff;

            &--content
            {
                height:100%;
                width:100%;
                padding:$grid-gutter-width/4 $grid-gutter-width/2;
                display:flex;
                flex-direction: column;
                align-items: center;
                justify-content:center;
            }

            &--secondaryLogo
            {
                //order:30;
                margin-bottom:40px;
                background:$white;
            }

            &--navigation
            {
                //order:10;
                margin-bottom:60px;
            }

            &--user
            {
                //order:20;
                margin-bottom:20px;
            }

            @include media-breakpoint-up(lg)
            {
                display:flex;
                opacity:1;
                height:auto;
                &--content
                {
                    justify-content: flex-end;
                    //padding:50px $grid-gutter-width 0 0;
                    padding:$grid-gutter-width/2 $grid-gutter-width/2;
                }
            }
            @include media-breakpoint-up(xl)
            {
                //padding:$grid-gutter-width/2 $grid-gutter-width/2;
            }
        }
        .toggle
        {
            position:absolute;
            z-index: 1;
            width:32px;
            height:32px;
            top:0;
            right:0;
            margin:$grid-gutter-width/6 $grid-gutter-width/3;
            svg
            {
                transition:$transition-base;
                border-radius: 50%;
                box-shadow: 0px 0px 6px 0px rgba(0,0,0,0.25);
            }
            path
            {
                transition:$transition-base;
                //fill:$white;
                &:nth-child(1) {
                    opacity:1;
                    fill:$white;
                }
                &:nth-child(2) {
                }
                &:nth-child(3) {
                }
            }

            @include media-breakpoint-up(lg)
            {
                display: none;
            }
        }

        @include media-breakpoint-up(lg)
        {
            padding: 0 $grid-gutter-width/2;
        }

        @include media-breakpoint-up(lg)
        {
            .brand
            {
                transition:$transition-base;
                transition-delay:0.35s;
            }

            &.large
            {
                position:$header-position;
            }
            &:not(.large)
            {
                height:auto;
                //background-color:$white;

                .menu--item,
                .integration--item.content,
                .navigation-links
                {
                    //box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.25);
                }
                //box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.25);               

                .brand
                {
                    svg
                    {
                        display:none;
                    }
                    .image
                    {
                        transform:none;
                    }
                    img
                    {
                        width:auto;
                        height: 60px;
                        max-height: 100%;
                        margin:$grid-gutter-width/2 0;
                    }
                }
            }
            .menu
            {
                background:transparent;

                &--item
                {
                    box-shadow: 0px 0px 6px 0px rgba(0,0,0,0.25);
                    height:60px;
                    display: flex;
                    align-items: center;
                    padding:$grid-gutter-width/2 $border-radius-lg/3;
                    margin-left:$grid-gutter-width;
                    border-radius: $border-radius-lg;
                }

                &--content
                {
                    flex-direction: row;
                    align-items: center;
                }

                &--secondaryLogo
                {
                    @extend .menu--item !optional;
                    //order:10;
                    margin-bottom:0;
                    //width:180px;

                    //@include theme-gradient-brand();


                    margin-right: -$grid-gutter-width;
                    padding-left: 80px;
                    border-radius: 45px;
                    border-top-right-radius: 0;
                    border-bottom-right-radius: 0;
                    height:90px;
                    width:auto;

                    padding-bottom:0;
                    padding-top:0;
                }

                &--navigation
                {
                    @extend .menu--item !optional;
                    //order:20;
                    margin-bottom:0;
                    background:$white;
                }

                &--user
                {
                    @extend .menu--item !optional;
                    //order:30;
                    margin-bottom:0;
                    margin-right: -130px;
                    z-index: 1;
                    background:$white;
                }
            }

            //transizione per quando la pagina scrolla
            .menu--content,
            .holder,
            .image
            {
                transition:all 0.5s ease-in-out;
            }

        }

        .toggler
        {
            margin-left:20px;
            cursor:pointer;
        }

    }

    
    #siteHeader.open
    {
        .menu
        {
            display:block;
            opacity: 1;
            //z-index:1;
        }
        .brand
        {
            //z-index:2;
        }
        /*
        .toggle path
        {            
            &:nth-child(2) {opacity:0;}

            &:nth-child(1) {
                transform:rotate(45deg) translateY(-24px) translateX(13px);
            }
            &:nth-child(3) {
                transform:rotate(-45deg) translateY(-7px) translateX(-24px);
            }
        }
        */
        .toggle svg
        {
            transform-origin: center center;
            transform:rotate(180deg);
        }
    }

    body.menuOpen
    {
        @include media-breakpoint-down(md)
        {
            overflow: hidden;
        }
    }
</style>